export const LOADING = "LOADING";
export const FILE_RESPONSE = "FILE_RESPONSE";
export const TEXT_RESPONSE = "TEXT_RESPONSE";
export const QUESTION = "QUESTION";
export const DELETE_CHAT_RESPONSE = "DELETE_CHAT_RESPONSE";
